import React from "react";
import { Row, Col, Modal, Form, Button } from "react-bootstrap";
import { useFormik } from "formik";
import DataGridForm from "../../../../components/common/DataGridForm";
import {
  AlertConfirmDeleteAll,
  AlertInfo,
  AlertSuccess,
} from "../../../../components/alert";
import ModalItemInformacionUtil from "./ModalItemInformacionUtil";
import { validateItemInformacionUtil } from "./validationSchemaItem";
import { removeSpecial, eliminarImagen } from "../../../../utils/tools";
import MediaUploader from "../../../../utils/media-uploader";
import ImagenPlaceholder from "../../../../assets/img/timeline/cd-icon-picture.svg";

const MAX_ITEMS_POR_BLOQUE = 3;

const emptyItemForm = {
  id: "",
  titulo: "",
  descripcion: "",
};

const ModalBloqueInformacionUtil = ({
  showModal,
  setShowModal,
  bloque,
  onSave,
  isNewBlock,
}) => {

  const [items, setItems] = React.useState([]);
  const [showModalItem, setShowModalItem] = React.useState(false);
  const [tituloBloque, setTituloBloque] = React.useState("");
  const [imagen, setImagen] = React.useState(null);

  React.useEffect(() => {
    if (showModal && bloque) {
      setItems(bloque.items || []);
      setTituloBloque(bloque.titulo || "");
      setImagen(bloque.imagen || null);
    }
  }, [showModal, bloque]);

  const formikItem = useFormik({
    initialValues: emptyItemForm,
    enableReinitialize: true,
    validationSchema: validateItemInformacionUtil,
    onSubmit: (values) => handleSaveItem(values),
  });

  const isEditingItem = Boolean(formikItem.values.id);

  const handleOpenNewItem = () => {
    if (items.length >= MAX_ITEMS_POR_BLOQUE) {
      AlertInfo(
        `Solo se permiten hasta ${MAX_ITEMS_POR_BLOQUE} items por bloque.`
      );
      return;
    }

    formikItem.resetForm({ values: emptyItemForm });
    setShowModalItem(true);
  };

  const handleEditItem = (data) => {
    formikItem.setValues({
      id: data.id ?? "",
      titulo: data.titulo || "",
      descripcion: data.descripcion || "",
    });

    setShowModalItem(true);
  };

  const handleDeleteItem = (id) => {
    AlertConfirmDeleteAll(
      "",
      "warning",
      async (response) => {
        if (response.isConfirmed) {
          setItems((prevItems) =>
            prevItems.filter((item) => String(item.id) !== String(id))
          );
          AlertSuccess("Item eliminado con éxito");
        }
      },
      "¡Atención!",
      "Continuar",
      "Cancelar",
      true,
      '<div class="swal2-html-container">Estás por eliminar el item. <br><br> ¿Querés continuar?</div>'
    );
  };

  const handleSaveItem = (values) => {
    const descripcion = removeSpecial(values.descripcion || "");
    const itemId = values.id;

    if (itemId !== "" && itemId != null) {
      setItems((prevItems) =>
        prevItems.map((item) =>
          String(item.id) === String(itemId)
            ? { ...item, titulo: values.titulo.trim(), descripcion }
            : item
        )
      );

      AlertSuccess("Item editado con éxito");
    } else {
      setItems((prevItems) => [
        ...prevItems,
        {
          id: Math.floor(Math.random() * 100000),
          titulo: values.titulo.trim(),
          descripcion,
          isNew: true,
        },
      ]);

      AlertSuccess("Item creado con éxito");
    }

    formikItem.resetForm({ values: emptyItemForm });
    setShowModalItem(false);
  };

  const onReorderItems = (e) => {
    const visibleRows = e.component.getVisibleRows();
    const newData = [...items];
    const toIndex = newData.indexOf(visibleRows[e.toIndex].data);
    const fromIndex = newData.indexOf(e.itemData);

    newData.splice(fromIndex, 1);
    newData.splice(toIndex, 0, e.itemData);

    setItems([...newData]);

  };

  const handleDeleteImagen = () => {

    if (imagen?.id) {

      eliminarImagen(imagen.id)

        .then(() => setImagen(null))

        .catch(() => setImagen(null));

      return;

    }



    setImagen(null);

  };



  const AccionItem = (data) => (

    <>

      <button

        type="button"

        className="btn btn-sm btn btn-success"

        onClick={() => handleEditItem(data)}

      >

        <i className="fa fa-pencil" />

      </button>{" "}

      <button

        type="button"

        className="btn btn-sm btn btn-danger"

        onClick={() => handleDeleteItem(data.id)}

      >

        <i className="fa fa-trash" />

      </button>

    </>

  );



  const handleCancel = () => {

    setShowModal(false);

    setItems([]);

    setTituloBloque("");

    setImagen(null);

  };



  const handleSaveBloque = () => {

    if (!imagen?.url) {

      AlertInfo("Debe cargar una imagen para el bloque.");

      return;

    }



    if (items.length === 0) {

      AlertInfo("El bloque debe tener al menos un item.");

      return;

    }



    onSave({

      ...bloque,

      titulo: tituloBloque.trim() || bloque?.titulo || "",

      imagen,

      items: items.map((item) => ({

        ...item,

        descripcion: removeSpecial(item.descripcion || ""),

      })),

    });



    handleCancel();

    AlertSuccess(

      isNewBlock ? "Bloque creado con éxito" : "Bloque actualizado con éxito"

    );

  };



  const itemsGridKey = items
    .map((item) => `${item.id}-${item.titulo}`)
    .join("|");

  return (

    <>

      <Modal

        dialogClassName="modal-90w"

        show={showModal}

        onHide={handleCancel}

        centered

      >

        <Modal.Body>

          <div className="mt-2">

            <Row>

              <Col>

                <label>{isNewBlock ? "Nuevo bloque" : "Editar bloque"}</label>

              </Col>

            </Row>



            <Col

              className="border"

              style={{

                marginTop: "15px",

                paddingTop: "15px",

                paddingBottom: "15px",

              }}

            >

              <Row>

                <Col lg={7}>

                  <Form.Group>

                    <label>Título del bloque</label>

                    <input

                      type="text"

                      className="form-control mb-2"

                      value={tituloBloque}

                      onChange={(e) => setTituloBloque(e.target.value)}

                      placeholder="Ej: Bloque 1"

                    />

                    <small className="text-muted">

                      Identificador interno para el CMS. Máximo{" "}

                      {MAX_ITEMS_POR_BLOQUE} items por bloque.

                    </small>

                  </Form.Group>



                  <Form.Group className="mt-3">

                    <label>Items del bloque</label>

                    {items.length > 0 ? (

                      <DataGridForm

                        key={itemsGridKey}

                        dataSource={items}

                        keyExpr="id"

                        allowReordering={true}

                        onReorder={onReorderItems}

                        columnHidingEnabled={true}

                        defaultPageSize={3}

                        columns={[

                          {

                            caption: "Título",

                            dataField: "titulo",

                          },

                          {

                            caption: "Acciones",

                            alignment: "center",

                            render: "AccionItem",

                            cellRender: { AccionItem },

                            hidingPriority: 0,

                          },

                        ]}

                      />

                    ) : (

                      <h5 className="mt-2">

                        Aún no hay items en este bloque. Haga click en

                        &quot;Añadir item&quot;.

                      </h5>

                    )}

                  </Form.Group>



                  <button

                    type="button"

                    className="btn btn-secondary mt-2"

                    onClick={handleOpenNewItem}

                    disabled={items.length >= MAX_ITEMS_POR_BLOQUE}

                  >

                    Añadir item

                  </button>

                  {items.length >= MAX_ITEMS_POR_BLOQUE && (

                    <small className="text-muted ml-2">

                      Máximo {MAX_ITEMS_POR_BLOQUE} items por bloque.

                    </small>

                  )}

                </Col>



                <Col lg={5}>

                  <Form.Group>

                    <label>Imagen</label>

                    <MediaUploader

                      setFieldValue={(name, value) => setImagen(value)}

                      field="imagen"

                      tipoMedia="imagen"

                      ancho={250}

                      alto={250}

                    />

                  </Form.Group>



                  <Row className="mt-2">

                    <Col md={8}>

                      <img

                        src={imagen?.url || ImagenPlaceholder}

                        alt="Vista previa"

                        className="img-fluid"

                        style={{

                          height: "11em",

                          objectFit: "cover",

                          backgroundColor: "#f0f0f0",

                        }}

                      />

                    </Col>

                    <Col md={4}>

                      <Button

                        style={{ marginTop: 120 }}

                        type="button"

                        onClick={handleDeleteImagen}

                        className="btn btn-danger btn-icon"

                        disabled={!imagen?.url}

                      >

                        <i className="fa fa-trash" />

                        Eliminar

                      </Button>

                    </Col>

                  </Row>



                  <Row className="mt-2">

                    <Col>

                      <span className="text-muted">

                        Se recomienda una imagen de 250px de ancho x 250px de

                        alto. En formato JPG o PNG.

                      </span>

                    </Col>

                  </Row>

                </Col>

              </Row>

            </Col>

          </div>



          <Row>

            <Col md={12}>

              <div className="mt-4">

                <div className="d-flex justify-content-end">

                  <button

                    type="button"

                    className="btn btn-danger"

                    onClick={handleCancel}

                  >

                    Cancelar

                  </button>

                  <button

                    type="button"

                    className="btn btn-success ml-2"

                    onClick={handleSaveBloque}

                  >

                    Guardar bloque

                  </button>

                </div>

              </div>

            </Col>

          </Row>

        </Modal.Body>

      </Modal>



      <ModalItemInformacionUtil

        showModal={showModalItem}

        setShowModal={setShowModalItem}

        formik={formikItem}

        isEditing={isEditingItem}

      />

    </>

  );

};



export default ModalBloqueInformacionUtil;


